module.exports = __webpack_public_path__ + "static/img/grow3_light.f91acef7.png";